
exports.pbkdf2 = require('./lib/async')

exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// ../.node/lib/node_modules/webpack/node_modules/node-libs-browser/node_modules/crypto-browserify/node_modules/pbkdf2/browser.js
// module id = 55
// module chunks = 0